class Spotted {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.spotted')

    if (!this.section)
      return

    this.form       = this.section.querySelector('.spotted__form')
    this.buttons    = this.section.querySelectorAll('.spotted__itemContact')
    this.popupValue = document.querySelector('.popup[data-popup="spotted-contact"] .popup__value')
    this.navPrev    = this.section.querySelector('.spotted__navPrev')
    this.navNext    = this.section.querySelector('.spotted__navNext')
    this.animation  = new Animation

    return true

  }

  setEvents() {

    this.buttons.each((item, index) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.showContact(index)

      })

    })

    if (this.navPrev != null) {

        this.navPrev.addEventListener('click', (e) => {

        e.preventDefault()

        this.wrapper = this.section.querySelector('.simplebar-content')
        this.initScroll(-this.wrapper.offsetHeight)

        })
    }

    if (this.navNext != null) {

        this.navNext.addEventListener('click', (e) => {

        e.preventDefault()

        this.wrapper = this.section.querySelector('.simplebar-content')
        this.initScroll(this.wrapper.offsetHeight)


        })
    }

  }

  showContact(index) {

    if (!this.popupValue)
      return

    const value = this.buttons[index].getAttribute('data-contact')
    this.popupValue.innerHTML = value

    document.body.bindCustomEvent('open-popup', 'spotted-contact')

  }

  initScroll(value) {

    this.animation.stop()

    this.animation.start(
      this.wrapper.scrollTop,
      value,
      1000,
      'easeOutCubic',
      (value) => { this.animationScroll(value) }
    )

  }

  animationScroll(value) {

    this.wrapper.scrollTop = value

  }

}
